import React from "react";

const ResultView = ({
  image,
  title,
  text,
  buttons = [],
  className = "",
  contentClassName = "",
}) => {
  return (
    <div className={`result-view__container overflow ${className}`}>
      <div className={`result-view__content ${contentClassName}`}>
        {image && (
          <div className="result-view__img">
            <img src={image} alt="Result image" />
          </div>
        )}
        {title && <div className="result-view__title">{title}</div>}
        {text && <div className="result-view__text">{text}</div>}
      </div>

      {buttons.length > 0 && (
        <div className="result-view__buttons">
          {buttons.map((btn, index) => (
            <div key={index} className="result-view__button">
              {btn}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ResultView;
